import { useLanguage } from "../contexts/LanguageContext";
import { motion } from "framer-motion";

const CORRIDOR_IMG = "https://customer-assets.emergentagent.com/job_medboard-exec/artifacts/ni62ugk2_Imagen%20pasillo%20hospital.png";

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
};

const transitionBase = { duration: 0.7 };
const transitionDelayed = { duration: 0.7, delay: 0.15 };

export default function ManagementLab() {
  const { t } = useLanguage();

  return (
    <section data-testid="lab-section" className="relative py-16 md:py-20 overflow-hidden">
      <div className="absolute inset-0 bg-[#0a0f1f]" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            {...fadeUp}
            transition={transitionBase}
          >
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src={CORRIDOR_IMG}
                alt="Hospital corridor"
                data-testid="lab-image"
                className="w-full h-[400px] object-cover rounded-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0a0f1f]/60 to-transparent" />
            </div>
          </motion.div>

          <motion.div
            {...fadeUp}
            transition={transitionDelayed}
          >
            <span className="font-outfit text-xs tracking-[0.3em] uppercase text-[#1a6cf5] mb-4 block">
              Laboratorio de gestión
            </span>
            <h2
              data-testid="lab-h2"
              className="font-playfair text-4xl md:text-5xl text-[#f8f9fa] tracking-tight mb-6 leading-tight"
            >
              {t("lab.h2")}
            </h2>
            <p
              data-testid="lab-text"
              className="font-outfit text-base md:text-lg text-[#94a3b8] leading-relaxed"
            >
              {t("lab.text")}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
